<template>
  <div class="EventsRecordsDataTable-container Content clearfix">
    <div>
      <div
        v-if="eventIsLocked"
        class="Notice Notice--warning u-flex u-flex-spaceBetween u-flex-alignCenter "
      >
        <div>
          <span class="Icon Icon-exclamation-triangle" /> The records for this event are currently being reprocessed.
          Please check back soon.
        </div>
      </div>
      <div
        v-if="totalUniqueRecords > 0 && !eventIsLocked"
        class="Notice Notice--info u-flex u-flex-spaceBetween u-flex-alignCenter "
      >
        <div>
          Only records that were successfully processed are listed.
        </div>
      </div>
      <div
        v-if="isMaxNumberOfResponsesSet"
        class="FormMaxNumberOfResponses"
      >
        Max Number of Registrations: {{ maxNumberOfResponses }} / Vacancies left: {{ totalOfRemainingResponsesToFill }}
      </div>
      <template v-if="totalValidationErrros">
        <div
          class="Notice Notice--warning u-flex u-flex-spaceBetween u-flex-alignCenter "
        >
          <div>
            <span class="Icon-s Icon-exclamation-triangle" />
            There are
            <strong>{{ totalValidationErrros.number }} records with validation errors</strong>. Please resolve them now.
          </div>
          <a
            class="Button Button--green"
            target="_blank"
            :href="totalValidationErrros.url"
          >Resolve</a>
        </div>
      </template>
      <template v-if="!ui.showPlaceHolder">
        <div class="ActionMenu-wrapper u-flex">
          <div
            v-click-outside="hideActionsMenu"
            class="ActionsMenu"
            @click="ui.showActionsMenu = true"
          >
            <p>Actions <span class="Icon Icon-chevron-down" /></p>
            <ul
              v-if="ui.showActionsMenu"
              class="Menu"
            >
              <li
                :class="{ disabled: selectedRecords.length === 0 }"
                @click="handleTableAction('deleteSelected')"
              >
                Delete Selected ({{ selectedRecords.length }})
              </li>
              <li @click="handleTableAction('deleteAll')">
                Delete All
              </li>
            </ul>
          </div>
        </div>
      </template>
      <div
        v-if="loadingState"
        class="js-loading"
      />
      <div :class="['DataTable']">
        <vuetable-pagination-info
          ref="paginationInfo"
          :css="paginationInfoConfig.css"
          :info-template="table.paginationInfoConfig.infoTemplate"
        />
        <span
          class="vuetable-pagination-info right view-all"
        ><span
           v-if="totalUniqueRecords > 0"
         > {{ totalUniqueRecords }} unique </span>
          <span
            v-if="totalIncomingRecords > 0"
          ><span v-if="totalUniqueRecords > 0">/</span> <span
            class="Icon-s Icon-cloud-download"
          /> {{ totalIncomingRecords }} incoming
            <tool-tip>
              <span
                slot="trigger"
                style="cursor: pointer;"
                class="Icon-s Icon-info-circle"
              />
              <p slot="tip">These records have not yet processed, but don't panic, they are on their way!</p>
            </tool-tip>
          </span>
          <span v-if="totalOfResponsesThatAreBeingReProcessed > 0">
            {{ totalOfResponsesThatAreBeingReProcessed }} response(s) being re-processed
            <tool-tip>
              <span
                slot="trigger"
                style="cursor: pointer;"
                class="Icon-s Icon-info-circle"
              />
              <p slot="tip">The event will be lock until there are no responses left to re-process.!</p>
            </tool-tip>
          </span>
          <span v-if="totalOfResponsesThatTriggeredUnexpectedExceptions > 0">
            {{ totalOfResponsesThatTriggeredUnexpectedExceptions }} response(s) failed to process
          </span>
        </span>
        <vue-table
          ref="vuetable"
          :class="['DataTable', { 'DataTable--hide': ui.showPlaceHolder }]"
          :api-mode="true"
          :api-url="table.options.apiUrl"
          :fields="table.options.columns"
          :append-params="additionalParams"
          :css="tableConfig.css"
          :per-page="tableConfig.perPage"
          :sort-order="table.options.sortOrder"
          pagination-path=""
          @vuetable:checkbox-toggled="handleCheckboxToggle"
          @vuetable:checkbox-toggled-all="handleCheckboxToggle"
          @vuetable:loading="loadingState = true"
          @vuetable:loaded="setTableStatus"
          @vuetable:load-error="handleDataTableError"
          @vuetable:pagination-data="handlePaginationDataLoaded"
        >
          <div
            slot="name"
            slot-scope="props"
            class="Name"
          >
            <p class="tempalte">
              {{ props.rowData.fullName }}
            </p>
          </div>
          <div
            slot="registeredAt"
            slot-scope="props"
            class="Name"
          >
            <p class="template">
              {{ props.rowData.registeredAt }}
            </p>
          </div>
          <div
            slot="emailAutomationsHealthStatus"
            slot-scope="props"
            class="Name"
          >
            <!-- emailAutomationsHealthStatus can be null -->

            <tool-tip v-if="props.rowData.emailAutomationsHealthStatus === 'grey'">
              <span
                slot="trigger"
                class="Icon-s Icon-envelope"
                style="color:dimgrey"
              />
              <p slot="tip">
                At least one automation is yet to be delivered.
              </p>
            </tool-tip>

            <tool-tip v-if="props.rowData.emailAutomationsHealthStatus === 'red'">
              <span
                slot="trigger"
                class="Icon-s Icon-envelope"
                style="color: red"
              />
              <p slot="tip">
                At least one automation was not delivered with success. Please view record to know more.
              </p>
            </tool-tip>

            <tool-tip v-if="props.rowData.emailAutomationsHealthStatus === 'green'">
              <span
                slot="trigger"
                class="Icon-s Icon-envelope"
                style="color: green"
              />
              <p slot="tip">
                Automations have been delivered with success.
              </p>
            </tool-tip>
          </div>
          <span
            slot="action"
            slot-scope="props"
          >
            <tool-tip>
              <span
                slot="trigger"
                class="Table-action"
                style="cursor:pointer"
              >
                <span
                  class="Icon-s Icon-eye"
                  @click="handleViewRecord(props.rowData.id)"
                />
              </span>
              <p slot="tip">View</p>
            </tool-tip>
            <tool-tip class="Tooltip-actions-menu">
              <span
                slot="trigger"
                class="Icon-s Icon-trash"
                style="cursor:pointer"
                @click="handleShowDeleteRecordsModal(props.rowData.id)"
              />
              <template #tip>
                <span>Delete</span>
              </template>
            </tool-tip>
          </span>
        </vue-table>
        <vuetable-pagination
          ref="pagination"
          class="u-floatRight"
          :css="paginationConfig.css"
          @vuetable-pagination:change-page="onChangePage"
        />
      </div>
      <div
        v-if="ui.showPlaceHolder"
        class="NoDataPlaceholder"
      >
        <span class="Icon-s Icon-users" />
        <h2>{{ Lang.records.noData.heading }}</h2>

        <template v-if="event.embedded_code_script_source !== null">
          <h4>{{ Lang.records.noData.message }}</h4>
          <button
            class="Button Button--green"
            @click="$emit('event-records-data-table:embed-form')"
          >
            Generate webform
          </button>
          <router-link
            v-if="event.can_access_integrations"
            class="Button Button--green"
            :to="{ name: 'event-integrations'}"
          >
            Add Integration
          </router-link>
        </template>
      </div>
    </div>
    <delete-event-records-modal
      v-model="ui.showDeleteRecordsModal"
      :records="selectedRecords"
      @delete-records:delete="handleDeleteEventRecords"
      @delete-records:cancel="handleCancelDeleteEventRecords"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import deleteRecordsModal from '../modals/delete-event-record';
import '@rmpenterprise/form-autocomplete-select/dist/autocomplete-select.esm.css';
import DataTableMixin from '../../../mixins/datatable-mixin';
import RmpTooltip from '../../common/tooltip.vue';
import Lang from '../../../lang/events-en';

export default {
  components: {
    'delete-event-records-modal': deleteRecordsModal,
    'tool-tip': RmpTooltip,
  },
  mixins: [DataTableMixin],
  props: {
    eventId: {
      type: Number,
      default: null,
    },
    eventIsLocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Lang,
      loadingState: false,
      paginationData: null,
      selectedRecords: [],
      // dateRanges: {
      //   start: '01/01/2020',
      //   end: '01/01/2100',
      // },
      ui: {
        hideFilters: false,
        loading: false,
        showActionsMenu: false,
        showEmbedModal: false,
        showPlaceHolder: false,
        showDeleteRecordsModal: false,
      },
      model: {
        filter: null,
      },
      table: {
        paginationInfoConfig: {
          infoTemplate: '{total} total records',
          css: {
            infoClass: 'view-all',
          },
        },
        options: {
          sortOrder: [
            {
              field: 'start_date',
              direction: 'desc',
            },
          ],
          apiUrl: `/ajax/web-forms/events/${this.eventId}/records`,
          columns: [
            {
              name: '__checkbox',
              titleClass: 'center aligned',
              dataClass: 'center aligned',
            },
            {
              name: 'fullName',
              sortField: 'fullName',
              title: 'Name',
            },
            {
              name: 'registeredAt',
              sortField: 'registeredAt',
              title: 'Registration Date',
            },
            {
              name: 'emailAutomationsHealthStatus',
              title: 'Automations',
            },
            { name: 'action' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState('global', {
      dataTableFilters: (state) => state.dataTableFilters,
    }),
    ...mapState('events', {
      event: (state) => state.event,
    }),
    totalUniqueRecords() {
      return this.paginationData
        ? this.paginationData.total
          - this.paginationData.meta.totalOfDuplicateRecords
        : null;
    },
    totalIncomingRecords() {
      return this.paginationData
      && this.paginationData.meta.totalOfIncomingRecords > 0
        ? this.paginationData.meta.totalOfIncomingRecords
        : null;
    },
    totalValidationErrros() {
      return this.paginationData
      && this.paginationData.meta.totalOfRecordsWithValidationErrors > 0
        ? {
          number: this.paginationData.meta.totalOfRecordsWithValidationErrors,
          url: this.paginationData.meta.linkToFixRecordsValidationErrors,
        }
        : null;
    },
    totalOfResponsesThatTriggeredUnexpectedExceptions() {
      return this.paginationData
      && this.paginationData.meta.totalOfResponsesThatTriggeredUnexpectedExceptions > 0
        ? this.paginationData.meta.totalOfResponsesThatTriggeredUnexpectedExceptions
        : null;
    },
    totalOfResponsesThatAreBeingReProcessed() {
      return this.paginationData
      && this.paginationData.meta.totalOfResponsesThatAreBeingReProcessed > 0
        ? this.paginationData.meta.totalOfResponsesThatAreBeingReProcessed
        : null;
    },
    maxNumberOfResponses() {
      return this.paginationData
          && this.paginationData.meta.maxNumberOfResponses;
    },
    isMaxNumberOfResponsesSet() {
      return this.paginationData
          && this.paginationData.meta.isMaxNumberOfResponsesSet;
    },
    totalOfRemainingResponsesToFill() {
      return this.paginationData
          && this.paginationData.meta.totalOfRemainingResponsesToFill;
    },
  },
  methods: {
    ...mapActions('events', {
      getEvent: 'getEvent',
      deleteEventRecords: 'deleteEventRecords',
    }),

    hideActionsMenu() {
      this.ui.showActionsMenu = false;
    },
    handleTableAction(value) {
      // selectedTo is important
      // Keeps track of vuetable-2 inbuild chekcbox toggle all/ single checkbox.
      const { tableData, selectedTo } = this.$refs.vuetable;

      if (value === 'deleteAll') {
        this.selectedRecords = tableData.map((item) => item.id);
      } else if (value === 'deleteSelected') {
        this.selectedRecords = selectedTo;
      }
      if (this.selectedRecords.length !== 0) {
        this.ui.showDeleteRecordsModal = true;
      }
    },
    handleShowDeleteRecordsModal(id) {
      this.selectedRecords = [id];
      this.ui.showDeleteRecordsModal = true;
    },
    handleCancelDeleteEventRecords() {
      const { selectedTo } = this.$refs.vuetable;

      if (selectedTo.length === 0) {
        this.selectedRecords = [];
      }

      this.ui.showDeleteRecordsModal = false;
    },
    handlePaginationDataLoaded(paginationData) {
      this.onPaginationData(paginationData);
      this.paginationData = paginationData;

      // Disable export when there is no data

      if (this.paginationData.data.length === 0) {
        document.querySelector('#ExportRecordsButton').setAttribute('disabled', 'disabled');
      } else {
        document.querySelector('#ExportRecordsButton').removeAttribute('disabled');
      }
    },
    handleCheckboxToggle() {
      const { selectedTo } = this.$refs.vuetable;
      this.selectedRecords = selectedTo;
    },
    handleDeleteEventRecords() {
      this.deleteEventRecords({
        eventId: this.event.id,
        eventRecordIds: this.selectedRecords,
      })
        .then(({ data }) => {
          // success
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'success',
          });
          this.selectedRecords = [];
          this.ui.loading = false;
          this.$refs.vuetable.refresh();
          this.ui.showDeleteRecordsModal = false;
        })
        .catch(({ data }) => {
          this.ui.isLoading = false;
          this.$bus.$emit('displayMsg', {
            text: data.data.message,
            type: 'warning',
          });
        });
    },
    handleViewRecord(recordId) {
      this.$router.push({
        name: 'single-event-record',
        params: { recordId },
      });
    },
  },
};
</script>

<style scoped lang="less">
.Content {
  margin: 0;
}

.ActionMenu-wrapper {
  position: absolute;
  right: 0;
  justify-content: flex-end;
}

.ActionsMenu {
  position: relative;

  p {
    cursor: pointer;
    border: 1px solid #cccc;
    padding: 7px 10px;
    border-radius: 3px;
  }

  .Menu {
    border: 1px solid #e9e9e9;
    position: absolute;
    background: white;
    z-index: 1;
    right: 0;
    top: 38px;
    width: 175px;

    li {
      padding: 10px;
      cursor: pointer;

      &.disabled {
        pointer-events: none;
        color: #e9e9e9;
      }
    }

    li:hover {
      background: #046ff0;
      color: white;
    }
  }
}

.Icon-trash {
  color: inherit;
}

.NoDataPlaceholder {
  margin: 110px 0px;
  text-align: center;

  .Icon-users {
    display: inline-block;
    background: #ebf4fd;
    vertical-align: middle;
    padding: 60px 48px;
    border-radius: 50%;
    font-size: 2.5rem;
    margin-bottom: 20px;
    color: #046ff0;
  }

  h2 {
    font-size: 2.8rem;
    margin-bottom: 0;
  }
}

.Name {
  p {
    margin: 0;
  }

  .list {
    color: #909090;
  }
}

.vuetable-pagination-info.right {
  margin-top: 10px;
  margin-right: 10px;
  float: left;
}

.Error-warning {
  color: red;
}

.FormMaxNumberOfResponses {
  color: #888;
  margin: 0 0 10px 0;
}

</style>
